<app-loader *ngIf="isDisabled"></app-loader>
<div>
	<div class="row m-0">
		<div class="col"></div>
		<div class="col-auto">
			<button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary"  [routerLink]="['/setting/attendancepolicies/add/',0]" [disabled]="isDisabled">
				<i class="bi bi-fingerprint" *ngIf="!isDisabled"></i>
				<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
					*ngIf="isDisabled"></span>
				{{!isDisabled?'Add Attendance Policy':'Loading...'}}
			</button>
		</div>
	</div>
	<div class="card border-radius-0 mt-1 p-0">
		<div class="card-header">
			Attendance Policies
		</div>
		<div class="card-body p-1" style="overflow: auto; width: 100%;">
			<table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
				<thead class="table-light">
					<tr>
						<th scope="col" style="width: 5px;">#</th>
						<th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
						<th>Policy Name</th>
						<th style="width: 80px;">Applicability</th>
						<th style="width: 80px;">Web Check</th>
						<th style="width: 100px;">Mobile Check</th>
						<th style="width: 80px;">Geo Tagging</th>
						<!-- <th>SiteQRCode Scanning</th> -->
						<!-- <th>EmployeeQR CodeScanning</th> -->
						<!-- <th>Selfie</th> -->
						<!-- <th>SelfieType</th> -->
						<!-- <th>IsOtherDuty</th> -->
						<!-- <th>IsAttendanceAll</th> -->
						<th style="width: 10px;">EmpType</th>
						<th style="width: 100px;">Default Policy</th>
						
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let TableData of TableDatas; let i = index">
						<th scope="row" style="width: 5px;">{{i+1}}</th>
						<td style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}"><div class="text-center"><i [routerLink]="['/setting/attendancepolicies/add/',TableData['ESS_AttendanceRuleID']]" class="bi bi-pencil-square text-warning"></i></div></td>
						<td>{{TableData['AttendanceRuleName']}}</td>
						<td style="width: 80px;">{{TableData['WebESSApplicability']}}</td>
						<td style="width: 80px;">{{TableData['WebCheckInOut']?'Yes':'No'}}</td>
						<td style="width: 100px;">{{TableData['MobileCheckInOut']?'Yes':'No'}}</td>
						<td style="width: 80px;">{{TableData['GeoTagging']?'Yes':'No'}}</td>
						<!-- <td>{{TableData['SiteQRCodeScanning']?'Yes':'No'}}</td> -->
						<!-- <td>{{TableData['EmployeeQRCodeScanning']?'Yes':'No'}}</td> -->
						<!-- <td>{{TableData['Selfie']?'Yes':'No'}}</td> -->
						<!-- <td>{{TableData['SelfieType']}}</td> -->
						<!-- <td>{{TableData['IsOtherDuty']?'Yes':'No'}}</td> -->
						<!-- <td>{{TableData['IsAttendanceAll']?'Yes':'No'}}</td> -->
						<td style="width: 10px;">{{TableData['EmpType']}}</td>
						<td style="width: 100px;">{{TableData['DefaultAttendance']?'Yes':'No'}}</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="card-footer">
            <div class="row">
                <div class="col">
                    <div class="row">
                    </div>
                    <div class="row">
                    </div>
                </div>
                <div class="col-auto">
                    <button  *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary" name="sample" (click)="exportToExcel()">
                        <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Excel':'Loading...'}}
                    </button>
                </div>
            </div>
        </div>
	</div>
</div>